export const checkUserForSub = userData => {
  let isSubscribed = false;
  if (!userData?.Subscriptions || userData?.Subscriptions.length < 1) {
    //no active subscription
    return isSubscribed;
  }

  userData?.Subscriptions.forEach(sub => {
    if (sub?.Subscribed && sub?.Active) {
      isSubscribed = true;
    }
  });

  return isSubscribed;
};

export const checkActiveNoSub = userData => {
  let isActiveSubscribed = false;
  if (!userData?.Subscriptions || userData?.Subscriptions.length < 1) {
    //no active subscription
    return isActiveSubscribed;
  }

  userData?.Subscriptions.forEach(sub => {
    if (!sub?.Subscribed) {
      isActiveSubscribed = true;
    }
  });

  return isActiveSubscribed;
};
